import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface QRDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  qrCodeImage: string | null;
  onSync: () => void;
  onClose?: () => void;
}

export const QRDialog = ({
  open,
  onOpenChange,
  qrCodeImage,
  onSync,
  onClose,
}: QRDialogProps) => {
  const { t } = useTranslation();
  
  const handleOpenChange = (newOpen: boolean) => {
    onOpenChange(newOpen);
    if (!newOpen && onClose) {
      onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md p-6">
        <DialogHeader className="flex flex-row items-center justify-between">
          <DialogTitle>{t("accounts.scan_qr_code")}</DialogTitle>
        </DialogHeader>
        {qrCodeImage && (
          <div className="flex justify-center p-6">
            <img
              src={qrCodeImage}
              alt={t("accounts.whatsapp_qr_code")}
              className="max-w-full h-auto"
            />
          </div>
        )}
        <div className="flex justify-center">
          <Button onClick={onSync}>
            <CheckCircle2 className="mr-2 h-4 w-4" />
            {t("common.confirm")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
